import { Permission, useUserPermissionGrantsQuery } from '../graphql'

// Uses userPermissionGrants (one row per permission, with all authorized object IDs
// grouped into an array) instead of the flat userAuthorizations.permissions list —
// that list returns one row per (permission, storeId) grant, which blows up to
// thousands of rows for admin-level accounts and is expensive for Apollo to cache.
export default function useCanCreateRefurbishedAdjustment( storeId?: number ): boolean {
	const { data, loading } = useUserPermissionGrantsQuery( {
		variables: {
			permissions: [ Permission.CanCreateRefurbishedAdjustmentByStoreId ],
			objectIds: storeId !== undefined ? [ String( storeId ) ] : [],
		},
		skip: storeId === undefined,
	} )

	if ( loading || storeId === undefined ) {
		return false
	}

	return !!data?.userPermissionGrants.some(
		( grant ) => grant.permission === Permission.CanCreateRefurbishedAdjustmentByStoreId &&
			grant.objectIds.some( ( objectId ) => Number( objectId ) === storeId )
	)
}
